import type { Admin, CurrentAdminRbacV2Grant } from '@gozoki/api-types'
import { createContext } from 'react'

export interface AuthContextType {
  authenticated: boolean
  user: Admin | null
  isLoading: boolean
  logout: () => Promise<void>
  rbacLoading: boolean
  /** Grants v2 du contrat retenu par `resolveRbacSession`, ceux dont l'ability est construite. */
  rbacGrantsV2: CurrentAdminRbacV2Grant[]
}

export const AuthContext = createContext<AuthContextType>({
  authenticated: false,
  isLoading: false,
  rbacLoading: false,
  rbacGrantsV2: [],
  logout: async () => {},
  user: null,
})
